/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CollectionLink({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M10.994 1a.6.6 0 0 0 .6.6h1.958L11.17 3.982a.6.6 0 1 0 .848.849L14.4 2.449v1.958a.6.6 0 1 0 1.2 0V1a.6.6 0 0 0-.6-.6h-3.406a.6.6 0 0 0-.6.6ZM.4 6.437V12A2.6 2.6 0 0 0 3 14.6h10a2.6 2.6 0 0 0 2.6-2.6V7.563a.6.6 0 0 0-1.2 0V12a1.4 1.4 0 0 1-1.4 1.4H3A1.4 1.4 0 0 1 1.6 12V6.132h7.088a.6.6 0 1 0 0-1.2H1.6V3c0-.221.18-.4.4-.4h3.063c.22 0 .4.179.4.4v.562a.6.6 0 0 0 .6.6H8.719a.6.6 0 1 0 0-1.2H6.662a1.6 1.6 0 0 0-1.6-1.562H2A1.6 1.6 0 0 0 .4 3v3.437Z" clipRule="evenodd" /></svg>;
}
;